<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
		<path
			d="M2.2626 10.5223V18H6.23929V10.5223H9.20466L9.82173 7.08398H6.23929V5.86758C6.23929 4.05 6.93521 3.35391 8.73157 3.35391C9.29037 3.35391 9.73946 3.36797 10 3.39609V0.277734C9.50977 0.140625 8.30991 0 7.61741 0C3.95269 0 2.2626 1.77539 2.2626 5.60391V7.08398H0V10.5223H2.2626Z"
			fill="#7B7B7B"
		/>
	</svg>
</template>
